import { render, staticRenderFns } from "./RequireNewPassword.vue?vue&type=template&id=5efbd89a&"
import script from "./RequireNewPassword.vue?vue&type=script&lang=js&"
export * from "./RequireNewPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports